import { Box } from "@mui/material";
import React, { useContext } from "react";
import BundleContext from "../../Contexts/BundleContext";
import { ImageModel } from "../../Models/ImageModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const ImageComponent: React.FC<IComponentProps<ImageModel>> = ({ component }) => {
  const bundle = useContext(BundleContext);
  const componentLayoutSx = getComponentLayout(component);

  const resource = component.EmbeddedResourceId ? bundle.EmbeddedResourceById[component.EmbeddedResourceId] : undefined;

  if (component.EmbeddedResourceId && !resource) {
    console.warn(`Embedded resource not found: ${component.EmbeddedResourceId}`);
  }

  const src = resource ? `data:image;base64,${resource.Content}` : undefined;
  const alt = component.Label ?? resource?.Name ?? "";

  return <Box component="img" src={src} alt={alt} sx={componentLayoutSx} />;
};

export default ImageComponent;
